/** The page language from <html lang>, which is not always the browser's. */
export function siteLocale() {
    return document.documentElement.lang || navigator.language;
}
